export default __webpack_public_path__ + "static/media/website.45f8d532.webp";